/**
 * `CAUSE-COLON` (the designer's joiner, console side): **a cause is its own sentence**, never « label : cause : more ». The label, a full stop, then
 * the cause with a capital and its own stop. The cause words are the API's, printed as they come: only the joint is made here. Local to `console-web`
 * (the shared kit is lane F's); the API composes the same joint for the sentences it composes (`causeSentence`, `intelligence/domain/unread-words.ts`).
 */
export function causeSentence(label: string, causeWords: string): string {
  const cause = causeWords.trim().replace(/\.$/u, "");
  if (cause === "") return `${label}.`;
  return `${label}. ${cause.charAt(0).toLocaleUpperCase("fr")}${cause.slice(1)}.`;
}
